import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { routePaths } from "../../consts";
import { consentUtil } from "../../utils";

import AppsBreadcrumb from "./breadcrumbsParts/AppsBreadcrumb";
import AppBreadcrumb from "./breadcrumbsParts/AppBreadcrumb";
import ConsentsBreadcrumb from "./breadcrumbsParts/ConsentsBreadcrumb";
import ConsentDetailsBreadcrumb from "./breadcrumbsParts/ConsentDetailsBreadcrumb";

import { BreadcrumbsContainer } from "./styled";
import PropTypes from "prop-types";

const AppManagementBreadcrumbs = ({ openConsentsModal }) => {
  const selectedConsent = useSelector((store) => store.consents.selectedConsent);
  const consentElements = useSelector((store) => store.consents.consentElements);

  const { location } = useHistory();

  const isSameData = useMemo(() => {
    if (consentElements?.length) {
      return consentUtil.checkIsSameConsentElements(selectedConsent?.items, consentElements);
    }

    return true;
  }, [selectedConsent, consentElements]);

  const onBreadcrumbClick = () => {
    if (!isSameData) {
      openConsentsModal();
    }
  };

  const isAppsPartAvailable = useMemo(() => {
    return location.pathname.includes(routePaths.APPS);
  }, [location]);

  const isAppPartAvailable = useMemo(() => {
    return location.pathname.includes(routePaths.CONSENTS);
  }, [location]);

  const isConsentsPartAvailable = useMemo(() => {
    return location.pathname.includes(routePaths.CONSENTS_CONSENT_ELEMENTS);
  }, [location]);

  const isConsentDetailsPartAvailable = useMemo(() => {
    return (
      location.pathname.includes(routePaths.CONSENT_ELEMENT_CREATE) ||
      location.pathname.includes(routePaths.CONSENT_ELEMENT_EDIT)
    );
  }, [location]);

  return (
    <BreadcrumbsContainer>
      {isAppsPartAvailable && (
        <AppsBreadcrumb onClick={onBreadcrumbClick} isSameConsentData={isSameData} slashAfter />
      )}

      {isAppPartAvailable && (
        <AppBreadcrumb onClick={onBreadcrumbClick} isSameConsentData={isSameData} />
      )}

      {isConsentsPartAvailable && (
        <ConsentsBreadcrumb
          onClick={onBreadcrumbClick}
          isSameConsentData={isSameData}
          slashBefore
        />
      )}

      {isConsentDetailsPartAvailable && (
        <ConsentDetailsBreadcrumb
          onClick={onBreadcrumbClick}
          isSameConsentData={isSameData}
          slashBefore
        />
      )}
    </BreadcrumbsContainer>
  );
};

AppManagementBreadcrumbs.propTypes = {
  openConsentsModal: PropTypes.func
};

export default AppManagementBreadcrumbs;
